import { type AxiosInstance, type AxiosError } from "axios";
import useSWR from "swr";
import type { KeyedMutator } from "swr";
import type { Design } from "@/features/dmManagement/types";
import { swrErrorHandler } from "@/features/dmManagement/api/handleApiError";

interface IResponse {
  data: Design[] | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<Design[]>;
  error: AxiosError | undefined;
}

/**
 * デザイン一覧を取得する。
 * @param apiClient - axios インスタンス
 * @param params - 絞り込み・並び替え条件（status, ordering）
 * @returns デザイン一覧・ローディング状態・mutate関数・エラー
 */
export const GetDesignsAPI = (
  apiClient: AxiosInstance,
  params?: { status?: string; ordering?: string }
): IResponse => {
  const fetcher = async (url: string): Promise<Design[]> => {
    const { data } = await apiClient.get<Design[]>(url, { params });
    return data;
  };

  const { data, isLoading, mutate, error } = useSWR<Design[], AxiosError>(
    ["/dm/designs/", params],
    async ([url]: [string]) => await fetcher(url),
    {
      revalidateOnFocus: false,
      onError: swrErrorHandler,
    }
  );

  return { data, isLoading, mutate, error };
};
